import { ButtonContained } from 'shared/ui/buttons/buttonContained';
import styles from './styles.module.scss';
import { formatWithLocale } from 'shared/lib/date';
import { Fragment } from 'react/jsx-runtime';
import { FC } from 'react';
import { IDay } from './types';
import { timeslotsStore } from 'entities/timeslots';

interface ScheduleFeedHeaderProps {
	selectedDay: IDay | null;
	setOpenCalendar: () => void;
	isOpenCalendar: boolean;
}

export const ScheduleFeedHeader: FC<ScheduleFeedHeaderProps> = ({
	selectedDay,
	setOpenCalendar,
	isOpenCalendar = false,
}) => {
	return (
		<Fragment>
			<div className={styles['schedule-header']}>
				<h2 className={styles['schedule-header__title']}>Дата</h2>
				<ButtonContained
					variant={isOpenCalendar ? 'primary' : 'secondary'}
					isLoading={timeslotsStore.loadingMonthsSlots}
					onClick={setOpenCalendar}
				>
					Календарь
				</ButtonContained>
			</div>

			{!isOpenCalendar && selectedDay && (
				<div className={styles['schedule-date']}>
					<h1>
						{formatWithLocale(
							selectedDay.date,
							"eeee, d MMMM yyyy 'года'",
						)}
					</h1>
				</div>
			)}
		</Fragment>
	);
};
